"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var StyledSignaturePad_1 = require("./StyledSignaturePad");
var __1 = require("..");
var SignaturePopup_1 = tslib_1.__importDefault(require("./SignaturePopup"));
var defaultHeight = 170; // 170px
var SignaturePad = /** @class */ (function (_super) {
    tslib_1.__extends(SignaturePad, _super);
    function SignaturePad() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isModalOpen: false
        };
        _this.openModal = function () {
            _this.setState({
                isModalOpen: true
            });
        };
        _this.closeModal = function () {
            _this.setState({
                isModalOpen: false
            });
        };
        _this.saveSignature = function (signatureData) {
            var onSave = _this.props.onSave;
            _this.setState({
                signatureData: signatureData,
                isModalOpen: false
            });
            if (onSave) {
                onSave(signatureData);
            }
        };
        return _this;
    }
    SignaturePad.prototype.render = function () {
        var _a = this.props, sectionHeight = _a.sectionHeight, placeholder = _a.placeholder, label = _a.label, rest = tslib_1.__rest(_a, ["sectionHeight", "placeholder", "label"]);
        var _b = this.state, signatureData = _b.signatureData, isModalOpen = _b.isModalOpen;
        return (react_1.default.createElement(StyledSignaturePad_1.Wrapper, null,
            react_1.default.createElement(__1.Box, null,
                react_1.default.createElement(__1.Text, null, label)),
            react_1.default.createElement(StyledSignaturePad_1.StyledImageWrapperButton, { onClick: this.openModal, sectionHeight: sectionHeight || defaultHeight, "aria-label": "open-signature-popup", "data-testid": "signature-button-area" }, signatureData ? (react_1.default.createElement(StyledSignaturePad_1.StyledSignaturePreview, { imgData: signatureData, role: "image", "aria-label": "signature-preview" })) : placeholder ? (react_1.default.createElement(__1.Text, { size: "40px", "data-testid": "signature-placeholder" }, placeholder)) : null),
            react_1.default.createElement(__1.Modal, { onClose: this.closeModal, isOpen: isModalOpen, size: "large", hideTitleBar: true, clickAwayClose: false },
                react_1.default.createElement(SignaturePopup_1.default, tslib_1.__assign({}, rest, { closeModal: this.closeModal, saveSignature: this.saveSignature })))));
    };
    return SignaturePad;
}(react_1.default.PureComponent));
exports.default = SignaturePad;
//# sourceMappingURL=SignaturePad.js.map